const TariffsList = () => {
  return import(/* webpackChunkName 'TariffsList' */ "@/components/Tariff/TariffsList/TariffsList.vue");
};

const TariffDetail = () => {
  return import(/* webpackChunkName 'TariffDetail' */ "@/components/Tariff/TariffDetail/TariffDetail.vue");
};

const TariffCreate = () => {
  return import(/* webpackChunkName 'TariffCreate' */ "@/components/Tariff/TariffCreate/TariffCreate.vue");
};

export default {
  path: "subscriptions/tariffs",
  name: "subscriptions_tariffs",
  meta: {
    label: "Subscriptions Tariffs",
  },
  redirect: {
    name: "subscriptions_tariffs_list",
  },
  component: {
    name: "TariffsList",
    render(c: any) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/",
      name: "subscriptions_tariffs_list",
      props: true,
      meta: {
        label: "List",
      },
      component: TariffsList,
    },
    {
      path: "tariff-detail/:id",
      name: "subscription_tariff_detail",
      props: true,
      meta: {
        label: "Tariff Detail",
      },
      component: TariffDetail,
    },
    {
      path: "tariff-create",
      name: "subscription_tariff_create",
      meta: {
        label: "Tariff Create",
      },
      component: TariffCreate,
    },
  ],
};
